// Module
var code = `<section class="page-body default-content">

  <h2>Textarea</h2>
  <p>
    Textareas allow users to enter multi-line text. SpyneJS styles textareas
    with consistent spacing, focus states, and validation feedback.
    They resize vertically by default for flexibility.
  </p>

  <!-- Default -->
  <h3>Default Textarea</h3>
  <div class="form-examples">
    <label for="textarea-default">Message</label>
    <textarea id="textarea-default" placeholder="Enter your message"></textarea>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="textarea-default"&gt;Message&lt;/label&gt;
&lt;textarea id="textarea-default" placeholder="Enter your message"&gt;&lt;/textarea&gt;
    </code></pre>
  </div>

  <!-- Focus -->
  <h3>Focus State</h3>
  <div class="form-examples">
    <label for="textarea-focus">Focused</label>
    <textarea id="textarea-focus">This field is focused</textarea>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="textarea-focus"&gt;Focused&lt;/label&gt;
&lt;textarea id="textarea-focus"&gt;This field is focused&lt;/textarea&gt;
    </code></pre>
  </div>

  <!-- Disabled -->
  <h3>Disabled Textarea</h3>
  <div class="form-examples">
    <label for="textarea-disabled">Disabled</label>
    <textarea id="textarea-disabled" placeholder="Cannot type here" disabled></textarea>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="textarea-disabled"&gt;Disabled&lt;/label&gt;
&lt;textarea id="textarea-disabled" placeholder="Cannot type here" disabled&gt;&lt;/textarea&gt;
    </code></pre>
  </div>

  <!-- Validation -->
  <h3>Validation States</h3>
  <div class="form-examples">
    <div>
      <label for="textarea-success">Success</label>
      <textarea id="textarea-success" class="success">All good here</textarea>
      <div class="input-hint">✓ Looks good</div>
    </div>
    <div>
      <label for="textarea-error">Error</label>
      <textarea id="textarea-error" class="error">Something went wrong</textarea>
      <div class="input-error-label">✕ Please fix this</div>
    </div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="textarea-success"&gt;Success&lt;/label&gt;
&lt;textarea id="textarea-success" class="success"&gt;All good here&lt;/textarea&gt;
&lt;div class="input-hint"&gt;✓ Looks good&lt;/div&gt;

&lt;label for="textarea-error"&gt;Error&lt;/label&gt;
&lt;textarea id="textarea-error" class="error"&gt;Something went wrong&lt;/textarea&gt;
&lt;div class="input-error-label"&gt;✕ Please fix this&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always associate <code>&lt;label&gt;</code> with textareas for clarity.</li>
    <li>Provide descriptive placeholder text only as a hint, not as a replacement for labels.</li>
    <li>Use validation hint text to communicate errors or success states, not color alone.</li>
  </ul>

  <!-- Back link -->
  <p>
    <a class="route-link" data-channel="ROUTE"
       data-page-id="elements" data-topic-id="forms" data-option-id=""
       href="/elements/forms">← Back to Forms Overview</a>
  </p>

</section>
`;
// Exports
module.exports = code;